import { useQuery } from '@tanstack/react-query';
import useBasket from '~/services/shop/hooks/basket/useBasket';
import useBasketReference from '~/services/shop/hooks/selectors/basket/useBasketReference';
import { getDeliveryDates } from '../../operations/basket';

export default function useDeliveryDates(deliveryId: number) {
    const { data: reference } = useBasketReference();
    const { data: updated } = useBasket((basket) => basket.updated.toString());

    return useQuery<string[], Error, Date[]>(
        ['deliveryDates', { reference, deliveryId, updated }],
        () => getDeliveryDates(reference, deliveryId),
        {
            enabled: !!reference,
            select: (data) => data.map((dateString) => new Date(dateString)),
        },
    );
}
